<template>
  <div>
    <v-row>
      <v-col>
        <v-card
          flat
          color="#f1f1f1"
          style="max-width: 600px"
          :loading="loading"
          :disabled="loading"
        >
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="title">
                {{ title }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-wrap">
                {{ description }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-card-text class="pt-5">
            <div class="text-right">
              <v-chip v-if="updating" color="info" dark small outlined label>
                <v-progress-circular
                  indeterminate
                  color="info"
                  size="15"
                  class="mr-2 py-2"
                  :width="2"
                ></v-progress-circular>
                {{ __("a salvar") }}
              </v-chip>

              <v-chip
                @click="updateParam(selected_statuses)"
                v-else-if="error == true"
                color="error"
                dark
                small
                outlined
                label
              >
                <v-icon small left>mdi-close</v-icon>
                {{ __("erro, tentar novamente") }}
              </v-chip>
              <v-chip v-else color="green" dark small outlined label>
                <v-icon small left>mdi-check</v-icon>
                {{ __("salvo") }}
              </v-chip>
            </div>

            <v-list class="mt-3">
              <div v-for="status in lead_statuses" :key="status.id">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon left :color="status.color" small>
                        mdi-circle
                      </v-icon>
                      {{ status.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-switch
                      v-model="selected_statuses"
                      :value="status.id"
                    ></v-switch>
                  </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>
              </div>
            </v-list>
            <v-col class="text-right">
              <v-btn color="primary" @click="saveSelections">{{
                __("Salvar")
              }}</v-btn>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbarSuccess" color="success">
      {{ __("alterações salvas com sucesso!") }}
      <v-btn color="white" text @click="snackbarSuccess = false">{{
        __("fechar")
      }}</v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbarError" color="error">
      {{ snackbarErrorMessage }}
      <v-btn color="white" text @click="snackbarError = false">
        {{ __("fechar") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { getParam, updateParam } from "@/services/configs/system_params";
import i18n from "@/mixins/i18n";

export default {
  mixins: [i18n],
  props: {
    title: String,
    description: String,
    paramId: String,
  },

  data() {
    return {
      i18n_prefix: "settings",
      selected_statuses: [],
      loading: false,
      updating: false,
      error: false,
      snackbarSuccess: false,
      snackbarError: false,
      snackbarErrorMessage: "",
    };
  },

  methods: {
    async getLeadStatusesActiveForUnityParam() {
      this.loading = true;
      try {
        const response = await getParam(this.paramId);
        this.selected_statuses = response.value;
      } finally {
        this.loading = false;
      }
    },
    async updateParam(value) {
      this.error = false;
      this.updating = true;
      try {
        await updateParam(this.paramId, value);
        this.snackbarSuccess = true;
      } catch (error) {
        this.error = true;
        if (error.response?.data?.message) {
          this.snackbarErrorMessage = error.response.data.message;
        } else {
          this.snackbarErrorMessage = this.__(
            "ocorreu um erro ao salvar as alterações"
          );
        }
        this.snackbarError = true;
      } finally {
        this.updating = false;
      }
    },
    saveSelections() {
      this.updateParam(this.selected_statuses);
    },
  },

  computed: {
    lead_statuses() {
      return this.$store.getters["lead_statuses/getLeadStatuses"];
    },
  },

  created() {
    this.$store.dispatch("lead_statuses/loadStatuses");
    this.getLeadStatusesActiveForUnityParam();
  },
};
</script>
